@if (chatItem) {
  <p class="reply-to">
    Replying to comment from <app-user-name [id]="chatItem.authorId"></app-user-name> {{chatItem.createdAt | fromNow}}
    <span class="quoting">{{chatItem.content | limitTo:100}}</span>
  </p>
}
